import { useEffect } from "react";

type SeoProps = {
  title: string;
  description?: string;
  image?: string;
  path?: string;
  jsonLd?: Record<string, unknown>;
};

const SITE_URL = "https://we-help.in";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

function setMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export const Seo = ({ title, description, image, path, jsonLd }: SeoProps) => {
  const serializedJsonLd = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", title);
    setMeta("name", "twitter:title", title);
    const url = path ? `${SITE_URL}${path}` : SITE_URL;
    setMeta("property", "og:url", url);
    setLink("canonical", url);
    const img = image || DEFAULT_IMAGE;
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:image", img);
  }, [title, description, image, path]);

  useEffect(() => {
    if (!serializedJsonLd) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.dataset.seoRoute = "true";
    el.text = serializedJsonLd;
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serializedJsonLd]);
  return null;
};

export default Seo;